'use strict';

var React = require('react');

var SvgButtonCornerRoundedMajor = function SvgButtonCornerRoundedMajor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M8.25 5a3.25 3.25 0 0 0-3.25 3.25v7.5a.75.75 0 0 1-1.5 0v-7.5a4.75 4.75 0 0 1 4.75-4.75h7.5a.75.75 0 0 1 0 1.5h-7.5Z"
  }));
};
SvgButtonCornerRoundedMajor.displayName = "ButtonCornerRoundedMajor";

exports.SvgButtonCornerRoundedMajor = SvgButtonCornerRoundedMajor;
